// 서버 fundingOptionPrice와 같은 규칙. 원본 옵션 가격은 바꾸지 않는다.
function optionUnitPrice(option, productType, persons) {
  const basePrice = Math.max(0, Math.round(Number(option && option.price) || 0))
  const code = String((option && option.code) || "").trim().toLowerCase()
  const descriptionCode = String((option && option.descriptionCode) || "").trim().toLowerCase()
  if (productType !== "group" || !(code.startsWith("retouch") || descriptionCode === "op_ret")) return basePrice
  return basePrice + (Math.max(1, Math.trunc(Number(persons) || 1)) - 1) * 10000
}
module.exports = { optionUnitPrice }
